import React, { useEffect, useMemo, useState } from 'react';
import Dialog from '../../../components/ui/Dialog/Dialog';
import updateUser from '../../../API/Manager/alterarUser';
import { Wand2, Copy, Check } from 'lucide-react';


export default function ResetPasswordDialog({ open, user, onClose, onReset }) {
  const [pwd, setPwd] = useState('');
  const [saving, setSaving] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (open) {
      setPwd('');
      setSaving(false);
      setCopied(false);
    }
  }, [open]);

  // Se o usuário editar manualmente, removemos o estado de "copiado"
  const handleInputChange = (e) => {
    setPwd(e.target.value);
    setCopied(false);
  }

  const canConfirm = useMemo(() => !!user && !!pwd && !saving, [user, pwd, saving]);

  const generate = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    const s = Array.from({ length: 12 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    setPwd(s);
    setCopied(false);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pwd);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  const confirm = async () => {
    if (!canConfirm) return;
    setSaving(true);
    try {
      await updateUser(user.id, { password: pwd, oldName: user.name });
      onReset?.();
      onClose?.();
      setTimeout(() => alert(`Nova senha de ${user.name}: ${pwd}`), 10);
    } catch (e) {
      console.error(e);
      alert('Erro ao atualizar a senha.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} title={user ? `Gerar nova senha — ${user.name}` : 'Gerar nova senha'}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        
        <div style={{display:'flex', flexDirection:'column', gap: 6}}>
          <label style={{fontSize: 13, fontWeight: 500, color: '#374151'}}>Senha</label>
          <div className="password-group">
            <input
              className="password-input"
              value={pwd}
              onChange={handleInputChange}
              placeholder="Clique em Gerar ou digite..."
              autoComplete="new-password"
            />
            
            <button 
              className="btn-tool btn-generate" 
              onClick={generate} 
              disabled={saving}
              title="Gerar senha aleatória"
            >
              <Wand2 size={16} />
              Gerar
            </button>

            <button 
              className={`btn-tool btn-copy ${copied ? 'success' : ''}`} 
              onClick={copy} 
              disabled={!pwd || saving}
              title="Copiar para área de transferência"
            >
              {copied ? <Check size={16} /> : <Copy size={16} />}
              {copied ? 'Copiado' : 'Copiar'}
            </button>
          </div>
        </div>

        {copied && (
           <div className="copy-feedback">
              <Check size={12} /> Senha copiada com sucesso.
           </div>
        )}

        <div className="dialog-actions">
          <button
            type="button"
            className="up-btn up-btn-ghost" 
            onClick={onClose} 
            disabled={saving}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="up-btn up-btn-primary"
            onClick={confirm} 
            disabled={!canConfirm}
          >
            {saving ? 'Salvando...' : 'Confirmar alteração'}
          </button>
        </div>

      </div>
    </Dialog>
  );
}